<template>
  <button
    type="button"
    class="ui-filter-chip"
    :class="[{ 'ui-filter-chip--active': active }, `ui-filter-chip--${variant}`]"
    @click="$emit('click', $event)"
  >
    <i v-if="icon" :class="icon" aria-hidden="true"></i>
    <span class="ui-filter-chip__label-group">
      <span class="ui-filter-chip__label">{{ label }}</span>
      <span v-if="count !== null && count !== undefined" class="ui-filter-chip__count">{{ count }}</span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'FilterChip',
  props: {
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    count: {
      type: [Number, String],
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'default',
    },
  },
  emits: ['click'],
};
</script>

<style src="../styles/FilterChip.css"></style>
